import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { AfterCallCanSeeOptions } from 'businessLogic/afterCallOption.js';
import Txt from '../../../inputs/textInput.js';
import { updateMeetingRoomForm } from '../../../../actions/meetingRoom';
import objectAssign from 'object-assign';
import { Dropdown } from 'semantic-ui-react';

export default function CenterPanel(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    //register the delegate event
    window.addEventListener('globalMessageHidden', globalMessageHidden);

    return () => {
      //Unregister the delegate event
      window.removeEventListener('globalMessageHidden', globalMessageHidden);
    };
  }, []);
  //function is a delegate event, and is fired when global message is hidden
  const globalMessageHidden = (e) => {
    if (e.detail && e.detail.text.indexOf('Meeting Room with that name') > 0) {
      window.$('input[name="meetingRoomName"]').focus();
    }
  };

  const changeCallQuality = (event, data) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('videoCallQualityId', data.value)));
  };
  const meetingRoomNameChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('name', value)));
  };

  const meetingRoomFormUpdated = (property, value) => {
    return objectAssign({}, props.meetingRoomForm, { [property]: value });
  };

  const changePostCallOption = (event, data) => {
    let updatedMeetingRoomForm = {
      callProviderUrl: props.meetingRoomForm.callProviderUrl,
      callerGuestUrl: props.meetingRoomForm.callerGuestUrl,
      postCallUrl: props.meetingRoomForm.postCallUrl,
      postCallOption: data.value,
    };
    let updatedAfterCallsForm = objectAssign({}, props.meetingRoomForm, updatedMeetingRoomForm);

    dispatch(updateMeetingRoomForm(updatedAfterCallsForm));
  };

  const postCallUrlChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('postCallUrl', value)));
  };

  const callProviderUrlChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('callProviderUrl', value)));
  };

  const callerGuestUrlChanged = (value) => {
    dispatch(updateMeetingRoomForm(meetingRoomFormUpdated('callerGuestUrl', value)));
  };

  let urlForOption2 =
    props.meetingRoomForm.postCallOption === 1 ? (
      <div>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="editMRForm" fieldClasses="mrtl">
          <Txt
            tabIndex="4"
            value={props.meetingRoomForm.postCallUrl || ''}
            titlePlaceholder={APP.LANGUAGE.EditMeetingRoomProperties.SameInformationSurvePageLabel}
            placeholder={APP.LANGUAGE.EditMeetingRoomProperties.URLPlaceholder}
            noTitle
            onChange={(value) => postCallUrlChanged(value)}
          />
        </ValidMe>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.EditMeetingRoomProperties.PostCallURLLeaveBlankForOption2}
        </label>
      </div>
    ) : (
      ''
    );

  let urlForOption3 =
    props.meetingRoomForm.postCallOption === 2 ? (
      <div>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="editMRForm" fieldClasses="mrtl">
          <Txt
            tabIndex="4"
            value={props.meetingRoomForm.callProviderUrl || ''}
            titlePlaceholder={APP.LANGUAGE.EditMeetingRoomProperties.DifferentSurveyGroupMemberUrl}
            placeholder={APP.LANGUAGE.EditMeetingRoomProperties.URLPlaceholder}
            noTitle
            onChange={(value) => callProviderUrlChanged(value)}
          />
        </ValidMe>
        <ValidMe validmefor="httpOrHttpsURL@canBeEmpty" group="editMRForm" fieldClasses="mrtl">
          <Txt
            tabIndex="5"
            value={props.meetingRoomForm.callerGuestUrl || ''}
            titlePlaceholder={APP.LANGUAGE.EditMeetingRoomProperties.DifferentSurveyOtherParticipant}
            placeholder={APP.LANGUAGE.EditMeetingRoomProperties.URLPlaceholder}
            noTitle
            onChange={(value) => callerGuestUrlChanged(value)}
          />
        </ValidMe>
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.EditMeetingRoomProperties.PostCallURLLeaveBlankForOption3}
        </label>
      </div>
    ) : (
      ''
    );

  return (
    <div className="ui form mrbml">
      <div className="pdts">
        <ValidMe
          validmefor="length@3-50"
          validmemessage={APP.LANGUAGE.Errors.MeetingRoomValidNameLength}
          trim={true}
          group="editMRForm"
        >
          <Txt
            tabIndex="1"
            maxLength={50}
            focusme="true"
            noTitle
            name="meetingRoomName"
            value={props.meetingRoomForm.name}
            onChange={(value) => meetingRoomNameChanged(value)}
            placeholder={APP.LANGUAGE.EditMeetingRoomProperties.NamePlaceholder}
          />
        </ValidMe>
      </div>
      <div className="pdts">
        <div>
          <div className="placeholder-label no-bold div-like color-placeholder">
            {APP.LANGUAGE.EditMeetingRoomProperties.CallQualityLabel}
          </div>
          <Dropdown
            tabIndex="2"
            defaultValue={props.meetingRoomForm.videoCallQualityId.toString()}
            onChange={(event, data) => changeCallQuality(event, data)}
            fluid
            selection
            options={props.callQualityOptions}
          />
        </div>
      </div>
      <div className="pdts">
        <label className="placeholder-label no-bold color-placeholder div-like">
          {APP.LANGUAGE.EditMeetingRoomProperties.SelectedSurveyOptionLabel}
        </label>
        <Dropdown
          tabIndex="3"
          className="after-call-dropdown"
          defaultValue={props.meetingRoomForm.postCallOption}
          onChange={(event, data) => changePostCallOption(event, data)}
          fluid
          selection
          options={AfterCallCanSeeOptions}
        />
        {urlForOption2}
        {urlForOption3}
      </div>
      <div className="mrbxxl hide-on-small-ress " />
    </div>
  );
}
